/**
 * COPY-571 string 2: the neutral recovery text shown when the invitation action answers 409
 * (#571 Q9, person-api#2044). Supplied by Charles, verbatim. Each string is one constant, and
 * every test asserts through the constants, so a wording change is one line and touches no test.
 * Do not reword here: the text must stay neutral, because a signed-out visitor must not learn
 * the invite's state.
 */
export const SIGN_IN_REQUIRED_TITLE = 'Sign in to continue';
export const SIGN_IN_REQUIRED_BODY =
  'Use your normal sign-in to carry on. We will take you to the right place after you sign in.';
export const SIGN_IN_REQUIRED_BUTTON = 'Sign in';
